export default "__VITE_ASSET__12167761__"